const legal = [
  { path: "/terms-of-service", label: "Terms of Service" },
  { path: "/privacy-policy", label: "Privacy Policy" },
];

export default legal;
